import { Component, OnDestroy } from '@angular/core';
import { config } from 'src/app/core/config/config';
import { ContentWrapperComponent } from '../layout/content-wrapper/content-wrapper.component';
import { LoadingSpinnerComponent } from 'src/app/components/loading-spinner/loading-spinner.component';

@Component({
  selector: 'app-contact',
  imports: [ContentWrapperComponent, LoadingSpinnerComponent],
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnDestroy {
  config = config;
  mapLoaded = false;
  private mapLoadDelayTimer: ReturnType<typeof setTimeout> | null = null;

  onMapFrameLoad(): void {
    if (this.mapLoadDelayTimer) {
      clearTimeout(this.mapLoadDelayTimer);
    }

    this.mapLoadDelayTimer = setTimeout(() => {
      this.mapLoaded = true;
      this.mapLoadDelayTimer = null;
    }, 300);
  }

  ngOnDestroy(): void {
    if (this.mapLoadDelayTimer) {
      clearTimeout(this.mapLoadDelayTimer);
    }
  }
}
